import { FetchMembers, FetchDepartments, FetchRoles, ContactValue } from '@fx-ui/jdy-design-biz';
import { AuthModel } from '@fx-ui/platform-sdk';
import { EMPTY_FN } from '@libs/shared';

/**
 * 业务上下文类型定义，可通过 TypeScript 的“声明合并”由业务方扩展。
 *
 * @example
 * 在业务项目的 `*.d.ts` 文件中:
 * declare module '@fx-ui/open-sdk' {
 *   export interface BizContext {
 *     corpId: string;
 *     appId:string
 *   }
 * }
 */
export interface BizContext {
    // 索引签名用于兼容未扩展类型的场景
    [key: string]: any;
}

/**
 * sdk全局状态
 */
class GlobalState {
    site = '';

    basePath = '';

    authModel: AuthModel | null = null;

    tracker: (event: string, ext?: Record<string, any> | string) => void = EMPTY_FN;

    request?: {
        onFetchMembers: FetchMembers;
        onFetchExternalMembers?: FetchMembers;
        onSearchMembers?: FetchMembers;
        onFetchDepartments: FetchDepartments;
        onFetchRoles: FetchRoles;
        onFetchExternalRoles?: FetchRoles;
        onSearchRoles?: FetchRoles;
        onResolveContactDetails: (idList: string[]) => Promise<ContactValue>;
    };

    /**
     * 业务侧自定义上下文，其类型可通过扩展 `BizContext` 接口来定义。
     * @see BizContext
     */
    bizContext: BizContext = {};

    /** 初始化全局状态 */
    init(config: GlobalStateInitConfig) {
        this.basePath = config.basePath;
        this.tracker = config.tracker;
        this.request = config.request;
        this.authModel = config.authModel;
        this.site = config.site;
    }

    /** 设置业务侧自定义上下文 */
    setBizContext(context: BizContext) {
        this.bizContext = context;
    }

    get hasContactPermission() {
        return this.authModel?.hasContactPermission || false;
    }
}

const globalState = new GlobalState();

/** 为open-sdk提供设置业务侧自定义上下文 */
const setBizContext = (context: BizContext) => {
    globalState.setBizContext(context);
};

/** 获取注入的自定义上下文 */
const getBizContext = () => {
    return globalState.bizContext;
};

/** 全局状态初始化配置 */
export type GlobalStateInitConfig = Pick<
    GlobalState,
    'site' | 'basePath' | 'tracker' | 'request' | 'authModel'
>;

export type { GlobalState };
export { globalState, setBizContext, getBizContext };
